import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import LanguageContext from "./../contexts/languageContext.js";
import { fieldReadyToSubmit } from "./../sharedLogic.js";
import { surveys } from "./../data";
import ContentParser from "./ContentParser.js";
import EnterCode from "./EnterCode.js";
import I18N from "./I18N.js";
import LanguageSelector from "./LanguageSelector.js";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import { useNavigate, useSearchParams } from "react-router-dom";
import Submitted from "./Submitted";

export default function Survey() {
  const navigate = useNavigate();
  const [code, setCode] = useState(false)
  let finalCode
  const [searchParams, setSearchParams] = useSearchParams();
  const query_code = searchParams.get("c")
  const { surveyId, submitted } = useParams();
  const [formState, setFormState] = useState({});
  const [loading, setLoading] = useState(false);
  const survey = surveys[surveyId];
  const [language, setLanguage] = useState(
    survey ? survey.settings.defaultLanguage || "de" : "de"
  );

  useEffect(() => {

    if (!surveys.hasOwnProperty(surveyId)) {
      console.log("wrong id")
      navigate("/");

    }

  }, [surveyId, navigate])

  if (!surveys.hasOwnProperty(surveyId)) {

    return null;
  }

  const direction = language === "ar" ? "rtl" : "ltr";

  if (submitted === "submitted") {
    return (
      <LanguageContext.Provider
        value={{
          dir: direction,
          rtl: direction === "rtl",
          language: language,
          defaultLanguage: survey.settings.defaultLanguage || "de",
        }}
      >
        <div className="container m-auto p-2 pb-4 border border-2 d-flex flex-column justify-start align-items-center">
          <Submitted />
        </div>
      </LanguageContext.Provider>
    );
  }

  if (!code && query_code && query_code.length === 5) {
    finalCode = query_code
  } else {
    finalCode = code
  }

  if ((!finalCode || finalCode.length !== 5)) {
    return <EnterCode handler={setCode} />
  }

  const formHandler = (key, value) => {
    const newState = JSON.parse(JSON.stringify(formState));
    setFormState({ ...newState, [key]: value });
  };

  const readyToSubmit = survey.content.every((c, i) =>
    fieldReadyToSubmit(c.config, formState)
  );

  const submitHandler = () => {
    let addedFormState = {};
    for (const c of survey.content) {
      if (!formState.hasOwnProperty(c.config.id)) {
        addedFormState[c.config.id] = "";
      }
    }
    setFormState({ ...formState, ...addedFormState });

    if (readyToSubmit) {
      setLoading(true);
      const columns = [];
      const answers = [];
      for (const x of Object.entries(formState)) {
        columns.push(x[0]);
        answers.push(`"${x[1].replace(/\n{2,}\s*/g, "\n").replace("'", '"')}"`);
      }
      axios
        .create({
          transformRequest: [(data, _headers) => JSON.stringify(data)],
        })
        .post(
          "https://hooks.zapier.com/hooks/catch/7193/bes559z/",
          {
            surveyId,
            formLanguage: language,
            code: finalCode,
            timestamp: new Date().toUTCString(),
            columns: columns.join(","),
            answers: answers.join(","),
          },
          {
            Accept: "application/json",
            "Content-Type": "application/json",
          }
        )
        .then(function (response) {
          console.log(response);
          navigate(`/s/${surveyId}/submitted`);
        })
        .catch(function (error) {
          setLoading(false);
          console.log(error);
        });
    } else {
      alert(I18N("form_not_complete", language));
    }
  };


  return (
    <LanguageContext.Provider
      value={{
        dir: direction,
        rtl: direction === "rtl",
        language: language,
        defaultLanguage: survey.settings.defaultLanguage || "de",
      }}
    >
      <div className="container m-auto p-2 pb-4 border border-2 d-flex flex-column justify-start align-items-center">
        <h1 className="text-center">{survey.title || "Unbenannte Umfrage"}</h1>
        <div className="mb-4">
          {survey.settings.languages.length > 0 && (
            <LanguageSelector
              languages={survey.settings.languages}
              selected={language}
              handler={setLanguage}
            />
          )}
        </div>
        {survey.content.map((c, i) => (
          <ContentParser
            key={`content_${i}`}
            content={c}
            handler={formHandler}
            formState={formState}
          />
        ))}
        {loading ? (
          <ClipLoader />
        ) : (
          <button
            onClick={submitHandler}
            className={`btn btn-lg btn-primary d-block w-100 ${!readyToSubmit ? "bg-opacity-50" : ""
              }`}
          >
            {I18N("submit", language)}
          </button>
        )}
      </div>
    </LanguageContext.Provider>
  );
}
